import { styled } from "@mui/material/styles";

export const Row = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  maxWidth: "12.813rem",
  minWidth: "10rem",
}));
